import request from '@/utils/request'
import config from '@/utils/config';
const getColorJson = (element: string): any => {
  let url = '/cw/choroplethic/color_json/tem'
  if (element.toLowerCase().indexOf('tem') > -1) {
    url = '/cw/choroplethic/color_json/tem'
  } else if (element.toLowerCase().indexOf('pre') > -1) {
    url = '/cw/choroplethic/color_json/pre'
  }
  return request.get(url, null).then((data: any) => {
    if (data.length > 0) {
      return data
    }
  })
}
const getGeoJson = (knowValues: number[][], colors: number[][], element: string): any => {
  let ele = ''
  if (element.toLowerCase().indexOf('pre') > -1) {
    ele = 'pre'
  }
  if (element.toLowerCase().indexOf('tem') > -1) {
    ele = 'tem'
  }
  const colorSettings: any[] = buildColorSettings(colors)
  const params = {areaCode: config.defaultStationObj.adminCode, type: ele, size: 90, knowValues, colorSettings}
  // console.log(JSON.stringify(params))
  return request.post('/cho_rest/cho', params).then((result: any) => {
    return result
  }).catch((e: any) => console.error(e))
}
const  buildColorSettings = (colors: number[][]) => {
  if (!colors || colors.length === 0) {return []}
  const colorSettings: any[] = []
  for (let i = 0; i < colors.length; i++) {
    const e = colors[i]
    colorSettings.push({
      l: e[0],
      h: e[1],
      r: e[2],
      g: e[3],
      b: e[4],
    })
  }
  return colorSettings
}
export default { getColorJson, getGeoJson }
